import {
  ShieldCheck,
  Sparkles,
  Layers,
  Lock,
  Zap,
  Building2,
} from "lucide-react";

const FEATURES = [
  {
    icon: ShieldCheck,
    title: "Privacy-First Parsing",
    desc: "Emails, phones, addresses, and social handles are scrubbed before storage. GDPR-friendly by design.",
  },
  {
    icon: Sparkles,
    title: "Claude Sonnet 4.5 Engine",
    desc: "Anthropic's flagship model extracts structured fields and writes 2-3 sentence narrative summaries per role.",
  },
  {
    icon: Layers,
    title: "4 Branded Templates",
    desc: "Classic, Modern, Compact, and Two-Column layouts — pick a global default or override per resume.",
  },
  {
    icon: Lock,
    title: "Blind-Hire Mode",
    desc: "Toggle anonymization to mask candidate names — ideal for bias-free shortlisting workflows.",
  },
  {
    icon: Zap,
    title: "Parallel Bulk Upload",
    desc: "Drop dozens of files at once — they parse concurrently with bounded throughput control.",
  },
  {
    icon: Building2,
    title: "Your Brand, Everywhere",
    desc: "Custom logo, footer text, and accent colors stamped on every page of every PDF and DOCX.",
  },
];

export default function FeatureGrid() {
  return (
    <section className="my-16" id="features">
      <div className="mb-8">
        <span className="overline">02 · capabilities</span>
        <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-[var(--text-primary)] mt-3">
          Six lenses for sharper
          <br />
          <span className="gradient-text">candidate clarity.</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {FEATURES.map((f) => {
          const Icon = f.icon;
          return (
            <div
              key={f.title}
              className="swiss-card swiss-card-hover lift-on-hover p-6 group"
              data-testid={`feature-card-${f.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
            >
              <div className="w-10 h-10 rounded-md bg-[var(--brand-primary)]/8 text-[var(--brand-primary)] flex items-center justify-center mb-4 group-hover:bg-[var(--brand-primary)] group-hover:text-white transition-colors">
                <Icon className="w-5 h-5" strokeWidth={1.75} />
              </div>
              <h3 className="font-heading font-semibold text-base text-[var(--text-primary)] mb-1.5">
                {f.title}
              </h3>
              <p className="text-sm leading-relaxed text-[var(--text-secondary)]">
                {f.desc}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
